import { Track, trackNames } from "@lib/types";

export function proposalListTitle(
  selectedTrack: Track,
  viewingInTrack: boolean,
): string {
  if (selectedTrack === "MAIN") {
    return viewingInTrack ? "General Proposals" : "Value-Specific Proposals";
  } else {
    const value =
      trackNames[selectedTrack].charAt(0).toUpperCase() +
      trackNames[selectedTrack].slice(1).toLowerCase();
    return viewingInTrack ? `${value} Proposals` : `Non-${value} Proposals`;
  }
}

export function proposalListSubtitle(
  selectedTrack: Track,
  viewingInTrack: boolean,
): string {
  if (selectedTrack === "MAIN") {
    return viewingInTrack
      ? "Proposals not specifically pursuing the values of freedom or fairness"
      : "Proposals specifically pursuing the values of freedom and/or fairness";
  } else {
    const value = trackNames[selectedTrack].toLowerCase();
    return viewingInTrack
      ? `Proposals specifically pursuing the value of ${value}`
      : `Proposals not specifically pursuing the value of ${value}`;
  }
}
